import { rpc } from './ws';

export interface SessionInfo {
  id: string;
  label: string;
  platform: string | null;
  ip: string | null;
  lastActive: string;
  expiresAt: string;
  createdAt: string;
  current: boolean;
}

export const fetchSessions = (_token: string) =>
  rpc<{ sessions: SessionInfo[] }>('sessions.list').then((r) => r.sessions);

export const terminateSession = (_token: string, id: string) =>
  rpc<{ ok: boolean }>('sessions.terminate', { id });

export const terminateOtherSessions = (_token: string) =>
  rpc<{ ok: boolean; terminated: number }>('sessions.terminateOthers');
